import Vue from "vue";
import {
  NetworkService,
} from "@/common/api.service";
import {
  FETCH_NETWORK_WIFI_LIST,
  NETWORK_WIFI_CONNECT,
  NETWORK_WIFI_WPS_START,
  NETWORK_WIFI_WPS_STATUS
} from "./actions.type";
import {
  SET_NETWORK,
  SET_NETWORK_LOADING,
  SET_SERVICES_STATUS,
  SET_NETWORK_WIFI_LIST,
  SET_NETWORK_WIFI_WPS_STATUS,
  SET_NETWORK_STATUS,
} from "./mutations.type";
import { promised } from "q";

const initialState = {
  network: null,
  loading: true,
  scanning: false,
  connecting: false,
  status: "ok",
  services: [],
  wifi_list: null,
  wifi_wps_status: {
    log : [],
    ssid : ""
  }
};

export const state = { ...initialState };

export const actions = {
  async fetchNetwork(context) {
    console.log("Fetching network settings...")
    const { data } = await NetworkService.get();
    console.log("Done", data)
    context.commit(SET_NETWORK, data);
    context.commit(SET_NETWORK_LOADING, false);
    return data;
  },
  async saveNetwork(context) {
    if (context.state.loading)
      return false
    console.log("Saving network settings...")
    let error = null

    context.commit(SET_NETWORK_LOADING, true);    
    let result
    result = await NetworkService.save(context.state.network);
    if (result.status == 200 && result.data.errors.length == 0) {
      result = await NetworkService.restart()
      if (result.status == 200 && result.data.errors.length == 0) {
        context.commit(SET_NETWORK_STATUS, "success");
        await context.dispatch("fetchNetwork");
      }else
        context.commit(SET_NETWORK_STATUS, "unable-restart-network");
    }else
      context.commit(SET_NETWORK_STATUS, "unable-save-network");
    //await sleep (5000);
    context.commit(SET_NETWORK_LOADING, false);
    console.log("Saving network settings... Done")
  },
  async restartNetwork(context) {
    console.log("Restart network serivice...")
    context.commit(SET_NETWORK_LOADING, true);
    const { data } = await NetworkService.restart();
    //await sleep (5000);
    context.commit(SET_NETWORK_LOADING, false);
    return data;
  },
  async restartNetworkStatus(context) {
    console.log("Get network serivice status...")
    context.commit(SET_NETWORK_LOADING, true);
    const { data } = await NetworkService.restart_status();
    context.commit(SET_SERVICES_STATUS, data);
    //await sleep (5000);
    context.commit(SET_NETWORK_LOADING, false);
    return data;
  },
  async [FETCH_NETWORK_WIFI_LIST](context) {
    console.log("Get network wifi list...")
    context.commit("setNetworkScanning", true);
    const { data } = await NetworkService.wifi_list();
    context.commit(SET_NETWORK_WIFI_LIST, data);
    console.log(data);
    //await sleep (5000);
    context.commit("setNetworkScanning", false);
    return data;
  },
  async [NETWORK_WIFI_CONNECT](context, {ssid, password}) {
    console.log("Connectiong with ssid and password", ssid, password)
    context.commit("setNetworkConnecting", true);
    const { data } = await NetworkService.wifi_connect(ssid, password);
    context.commit("setNetworkConnecting", false);
    if (data.ssid == ssid) {
      context.commit("setCurrentWifi", ssid);
    }else {
      context.commit("setCurrentWifi", null);
    }
    return data;

  },
  async [NETWORK_WIFI_WPS_START](context) {
    console.log("Connectiong with wps")
    context.commit(SET_NETWORK_WIFI_WPS_STATUS, []);
    context.commit(SET_NETWORK_LOADING, true);
    const { data } = await NetworkService.wifi_wps();
    context.commit(SET_NETWORK_LOADING, false);

  },
  async [NETWORK_WIFI_WPS_STATUS](context) {
    console.log("Get wifi-wps status")
    const { data } = await NetworkService.wifi_wps_status();
    context.commit(SET_NETWORK_WIFI_WPS_STATUS, data);
    return data;

  }
};


export const mutations = {
  [SET_NETWORK](state, data) {
    state.network = data;
  },
  [SET_NETWORK_STATUS](state, data) {
    state.status = data;
  },
  [SET_NETWORK_LOADING](state, data) {
    state.loading = data;
  },
  setNetworkScanning(state, data) {
    state.scanning = data
  },
  setNetworkConnecting(state, data) {
    state.connecting = data;
  },
  [SET_SERVICES_STATUS](state, data) {
    state.services = data
  },
  [SET_NETWORK_WIFI_LIST](state, data) {
    state.wifi_list = data
  },
  [SET_NETWORK_WIFI_WPS_STATUS](state, data) {
    state.wifi_wps_status = data
  },
  setCurrentWifi(state, data) {
    state.network.wlan0_current_ssid = data;
  }
};

const getters = {
  network(state) {
    return state.network;
  },
  loading(state) {
    return state.loading;
  },
  services(state) {
    return state.services;
  },
  wifi_list(state) {
    return state.wifi_list;
  },
  wifi_wps_status(state) {
    return state.wifi_wps_status;
  },
  scanning(state) {
    return state.scanning;
  },
  connecting(state) {
    return state.connecting;
  },
};

export default {
  state,
  actions,
  mutations,
  getters
};
